import {
  FNOL_UPDATE_ID_FLUX,
  FNOL_UPDATE_EXECUTION_CODE_MUT,
  FNOL_MAVALUE_REPORT_COMPONENT_MUT,
  FNOL_DAMAGES_CONFIRMED_MUT
} from '@/store/types'

export default {
  [FNOL_UPDATE_ID_FLUX] (state, payload) {
    state.idFlux = payload
  },
  [FNOL_UPDATE_EXECUTION_CODE_MUT] (state, payload) {
    state.executionCode = payload
  },
  [FNOL_MAVALUE_REPORT_COMPONENT_MUT] (state, payload) {
    state.fnolMavalueReportComponent = payload
  },
  [FNOL_DAMAGES_CONFIRMED_MUT] (state, payload) {
    state.damagesConfirmed = payload
  }
}
